import { Component, EventEmitter, Input, Output, Inject } from "@angular/core";
import { Observable, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpErrorResponse } from "@angular/common/http";

import { MatTableDataSource } from '@angular/material/table';

import { CommandRelay } from '../../../../shared/commands/command-relay.class';

import { EnvelopeDocusignEntity, Signer } from "../../entities/envelope-docusign.entity";
import { PlanPreventionService } from "../../services/plan-prevention.service";

@Component({
	selector: 'docusign-enveloppe-dialog',
	templateUrl: 'docusign-enveloppe-dialog.html',
	styleUrls: ['docusign-enveloppe-dialog.css']
})
export class DocusignEnveloppeDialogComponent {

	displaySubject = new Subject<boolean>();
	
	envelopeColumns: string[] = ['sentDateTime', 'status', 'dateRelance', 'dateFinalisation', 'actions'];
	signerColumns: string[] = ['nomPrenom', 'email', 'hasSigned', 'sentDateTime', 'dateSignature'];

	getIntervenantLabel = (intervenant: any) => (intervenant.prenom ? intervenant.prenom + ' ' : '')  + intervenant.nom;
	
	envelope!: EnvelopeDocusignEntity;
	envelopeDatasource!: MatTableDataSource<EnvelopeDocusignEntity>;
	signatairesDatasource!: MatTableDataSource<Signer>;

	constructor(@Inject(PlanPreventionService) private planPreventionService: PlanPreventionService) { }
	
	@Input() id: string = 'docusignEnvelopeDialog';
	@Output() onEnvelopeCancellation = new EventEmitter<void>();
	
	pdpId!: number;

	private initCommandsRelay = new CommandRelay<string>(command => {
		let initInfos = command.split(';');
		this.display(initInfos[0], initInfos[2] === 'true');
		this.pdpId = Number(initInfos[1]);
		
	});
	@Input() set initCommands(obs: Observable<string> | null | undefined) {
		this.initCommandsRelay.register(obs);
	}

	private display(envelopeId: string, isEnvelopeRetryable: boolean) {
		console.log('demande visualisation enveloppe: ', envelopeId);
		this.planPreventionService.getEnvelope(envelopeId).subscribe(
			(docusignEnvelope: EnvelopeDocusignEntity) => {
				this.envelope = docusignEnvelope;
				this.envelope.isRetryable = isEnvelopeRetryable && docusignEnvelope.signers.some( signer => !signer.hasSignedEnvelope );
				this.envelope.signers.forEach( $ => $.dateEnvoi = this.envelope.sentDateTime );
				this.envelopeDatasource = new MatTableDataSource([this.envelope]);
				this.signatairesDatasource = new MatTableDataSource(this.envelope.signers);
				this.displaySubject.next(true);
			}, (err: any) => {
				console.log(err);
				if (err.error && err.error.message) {
					alert(err.error.message);
				} else {
					alert('Impossible de récupérer le détail de cette enveloppe');
				}
			}
		);
	}
	
	telecharger(envelope: EnvelopeDocusignEntity): boolean {
		console.log('on souhaite telecharger envelope: ', envelope);
		this.planPreventionService.loadDocusignDocument(envelope.envelopeId).subscribe(
			(blob: Blob) => {
				const fileName: string = envelope.envelopeId + '.pdf';
				const objectUrl: string = URL.createObjectURL(blob);
				const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
				a.href = objectUrl;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();        
				
				document.body.removeChild(a);
				URL.revokeObjectURL(objectUrl);
  			},
			(err: any) => {
    			console.log('Could not download the file, error: ', err);
			}
		);
		return false;
	}

	cancel(envelope: EnvelopeDocusignEntity): boolean {
		console.log('on souhaite annuler envelope: ', envelope);
		if (confirm('Vous êtes sur le point d\'annuler l\'enveloppe DocuSign. Pour confirmer l\'annulation, cliquer sur OK')) {
			this.planPreventionService.annulerEnvelope(envelope.id, this.pdpId).pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("L'annulation de l'enveloppe n'a pas pu être réalisée, merci de réessayer plus tard ou contacter un administrateur");
						}
						throw new Error();
					}
				)
			).subscribe(
				() => {
					alert('L\'enveloppe a été annulée');
					this.displaySubject.next(false);
					this.onEnvelopeCancellation.emit();
				}
			);
		}
		return false;
	}
	
	relancer(envelope: EnvelopeDocusignEntity): boolean {
		console.log('on souhaite relancer envelope: ', envelope);
		if (confirm('Vous êtes sur le point de relancer les demandes de signature. Pour confirmer, cliquer sur OK')) {
			this.planPreventionService.relancerEnvelope(envelope.id).pipe(
				catchError(
					(response: HttpErrorResponse) => {
						if (response.error && response.error.message) {
							alert(response.error.message);
						} else {
							alert("La relance de l'enveloppe n'a pas pu être réalisée, merci de réessayer plus tard ou contacter un administrateur");
						}
						throw new Error();
					}
				)
			).subscribe(
				() => alert('Les signataires de cette enveloppe ont été relancés')
			);
		}
		return false;
	}

	onCloseRequested() {
		this.displaySubject.next(false);
	}
	
}